<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M14 13v8l-4-2v-6L2.95 4h18.1L14 13z"/></svg>